module.exports = __webpack_public_path__ + "img/easel.5668b175.png";